import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, Container } from 'reactstrap';

/**
 * Peringatan saat user membuka halaman yang datanya ada, tapi statusnya
 * belum sampai pada tahap yang mengizinkan data itu ditampilkan.
 * Berbeda dari 404 (data tidak ada) maupun 403 (user tidak berhak).
 */
const DataNotAvailable = ({
  title = 'Data Belum Tersedia',
  message = 'Halaman ini belum dapat dibuka karena datanya belum sampai pada tahap tersebut.',
  backTo = '/dashboard',
  backLabel = 'Kembali ke Dashboard',
}) => (
  <div className='page-content'>
    <Container fluid>
      <div className='row justify-content-center'>
        <div className='col-md-8 col-lg-6'>
          <Card className='mt-5'>
            <CardBody className='text-center p-4 p-sm-5'>
              <div className='hy-empty-icon bg-warning-subtle text-warning'>
                <i className='ri-time-line' aria-hidden='true'></i>
              </div>
              <h4 className='mb-2'>{title}</h4>
              <p className='text-muted mb-4' style={{ whiteSpace: 'pre-line' }}>
                {message}
              </p>
              <Link to={backTo} className='btn btn-primary px-4'>
                {backLabel}
              </Link>
            </CardBody>
          </Card>
        </div>
      </div>
    </Container>
  </div>
);

export default DataNotAvailable;
